import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

const selectLoanLodeStarQuestionsState = createSelector(
  selectLoanApplication,
  ({ loanLodeStarQuestions }) => loanLodeStarQuestions,
);

export const selectLoanLodeStarQuestions = createSelector(
  selectLoanLodeStarQuestionsState,
  ({ questions }) => questions || [],
);

export const selectLoanLodeStarQuestionAnswers = createSelector(
  selectLoanLodeStarQuestionsState,
  ({ answers }) => answers || {},
);
